import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#C14D4D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink target="_blank" href="https://www.facebook.com/mannasushivancouver/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Manna Sushi Facebook"
              />
            </CFLink>
            {/*<CFLink href="https://www.yelp.ca/biz/sushi-modo-burnaby-3">
              <CFImage w="45px" pr="10px" src={yelp} alt="Manna Sushi Yelp" />
            </CFLink>*/}
            {/*<CFLink href="https://www.zomato.com/vancouver/sushi-modo-cariboo-lougheed-burnaby">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Manna Sushi Zomato"
              />
            </CFLink>*/}
            {/*<CFLink href="https://www.instagram.com/sushimodo/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Manna Sushi Instagram"
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C14D4D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink target="_blank" href="https://www.facebook.com/mannasushivancouver/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Manna Sushi Facebook"
                hover
              />
            </CFLink>
            {/*<CFLink href="https://www.yelp.ca/biz/sushi-modo-burnaby-3">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Manna Sushi Yelp"
                hover
              />
            </CFLink>*/}
            {/*<CFLink href="https://www.zomato.com/vancouver/sushi-modo-cariboo-lougheed-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Manna Sushi Zomato"
                hover
              />
            </CFLink>*/}
            {/*<CFLink href="https://www.instagram.com/sushimodo/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Manna Sushi Instagram"
                hover
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
